<template>
  <div>
    <div
      class="progress-bar"
      :class="[{ progress_finished: isFinished }, { progress_error: isError }]"
      :style="cssVars"
    >
      <svg
        v-if="isFinished && theme"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        class="success-icon"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.35938" cy="6.6875" r="6.6875" fill="#3A4562" />
        <path
          d="M4.20117 7.26172L5.92383 8.98438L10.5176 4.39062"
          fill="#3A4562"
        />
        <path
          d="M4.20117 7.26172L5.92383 8.98438L10.5176 4.39062"
          stroke="#22C55E"
          stroke-width="1.72266"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <svg
        v-else-if="isFinished && !theme"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 15 14"
        class="success-icon"
        fill="none"
      >
        <circle cx="7.35938" cy="7.0127" r="6.6875" fill="#F7FAFC" />
        <path
          d="M4.20117 7.58691L5.92383 9.30957L10.5176 4.71582"
          stroke="#22C55E"
          stroke-width="1.72266"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div class="progress-bar__inside">
        <svg
          v-if="!isFinished"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 26 27"
          fill="none"
          @click="close"
        >
          <path
            d="M7.88257 10.9803L16.1517 19.2494C16.5814 19.6791 17.278 19.6791 17.7077 19.2494C18.1374 18.8198 18.1374 18.1231 17.7077 17.6934L9.43859 9.42431C9.00891 8.99462 8.31226 8.99462 7.88257 9.42431C7.45289 9.85399 7.45289 10.5506 7.88257 10.9803Z"
            fill="#FF4747"
          />
          <path
            d="M9.43834 19.2495L17.7075 10.9804C18.1371 10.5507 18.1371 9.85407 17.7075 9.42439C17.2778 8.9947 16.5811 8.9947 16.1515 9.42438L7.88233 17.6935C7.45265 18.1232 7.45265 18.8198 7.88233 19.2495C8.31201 19.6792 9.00866 19.6792 9.43834 19.2495Z"
            fill="#FF4747"
          />
        </svg>
        <slot :class="{ slot: !isFinished }" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CircularProgressBar",
  props: {
    percentage: {
      type: String,
      default: "0%",
    },
    isFinished: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.theme = this.getTheme === "dark";
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getTheme"]),
    cssVars() {
      return {
        "--percent": this.isFinished ? "100%" : this.percentage,
      };
    },
  },
};
</script>

<style scoped>
.progress-bar {
  @apply w-9 h-9 
   rounded-full 
   relative 
   flex 
   justify-center 
   items-center 
   pointer-events-none
   hover:cursor-pointer;
  background-image: conic-gradient(
    #aac7fc var(--percent),
    #d4e4fd var(--percent)
  );
}
.dark .progress-bar {
  background-image: conic-gradient(
    #5d88ef var(--percent),
    #494E60 var(--percent)
  );
}
.progress-bar.progress_finished {
  @apply cursor-default;
  background-image: conic-gradient(
    #5d88ef var(--percent),
    #494E60 var(--percent)
  );
}
.progress-bar.progress_finished .success-icon {
  @apply w-[14px] h-[14px] absolute z-10 top-0 right-0;
}
.progress-bar.progress_error {
  background-image: conic-gradient(
    #7ea5f7 var(--percent),
    #aac7fc var(--percent)
  );
}
.progress-bar::after {
  content: "";
  @apply absolute
   left-1/2
   top-1/2
   -translate-y-2/4
   -translate-x-2/4
   w-[calc(100%-5px)]
   h-[calc(100%-5px)]
   bg-white
   dark:bg-[#31343F]
   rounded-full;
}
.progress-bar__inside {
  @apply relative z-10 pointer-events-auto;
}
.progress-bar__inside svg {
  @apply hidden;
}
.progress-bar:hover .progress-bar__inside > * {
  @apply hidden;
}
.progress-bar:hover.progress_finished .progress-bar__inside > * {
  @apply block;
}
.progress-bar:hover .progress-bar__inside svg {
  @apply block w-[26px] h-[26px];
}
</style>
